import Vue from "vue";
import VueRouter from 'vue-router';
//第三方库需要use一下才能用
Vue.use(VueRouter)


import redRose from "./components/ThreeJS/ThreeJS_Products_RedRose.vue";
import materialRack from "./components/ThreeJS/ThreeJS_Products_MaterialRack.vue";
import dataVmaterialRack from "./components/DataV/MaterialRack/DataV_Demos_MaterialRack.vue";
import batamanCar from "./components/ThreeJS/ThreeJS_Products_BatamanCar.vue";
import MRNumber from "./components/DataV/MaterialRack/DataV_Demo_MaterialRack_Left_Side_New.vue";
import dataV_layout_materialRack from "./components/DataV/Layout/DataV_Demo_layout_MaterialRack.vue";
import ShowDataV from "./components/DataV/DataVShow.vue";
import threeJS_start from "./components/ThreeJS/ThreeJS_Products_Star.vue";


var keywordinfo = "数字孪生,数字映射系统,数字双胞胎,3D模型监控,3D建模,threeJS,PLC,OPCUA,MQTT,物联网,产线MES系统,OPC UA API,OPC-UA ,智能感知,识别技术与普适计算,融合应用,3D建模, IoT,Internet of Things,重庆乾端科技有限公司,乾端科技有限公司,乾端,重庆乾端";
var des = "重庆乾端科技有限公司-诚信赢天下";
const routes = [
  {
    path: "/redRose",
    name: "redRose",
    component: redRose,
    meta: {
      title: '3D素材玫瑰',
      content: {
        keywords: keywordinfo,
        description: des

      }
    }
  },
  {
    path: "/threeJS_start",
    name: "threeJS_start",
    component: threeJS_start,
    meta: {
      title: 'threeJS_start',
      content: {
        keywords: keywordinfo,
        description: des

      }
    }
  },
  {
    path: "/batamanCar",
    name: "batamanCar",
    component: batamanCar,
    meta: {
      title: '3D蝙蝠侠汽车',
      content: {
        keywords: keywordinfo,
        description: des

      }
    }
  },
  {
    path: "/materialRack",
    name: "materialRack",
    component: materialRack,
    meta: {
      title: '3D仓储料架',
      content: {
        keywords: keywordinfo,
        description: des

      }
    }
  },
  {
    path: "/dataVmaterialRack",
    name: "dataVmaterialRack",
    component: dataVmaterialRack,
    meta: {
      title: '3D可视化仓储料架',
      content: {
        keywords: keywordinfo,
        description: des

      }
    }
  },
  {
    path: "/dataV_layout_materialRack",
    name: "dataV_layout_materialRack",
    component: dataV_layout_materialRack,
    meta: {
      title: '3D可视化仓储料架',
      content: {
        keywords: keywordinfo,
        description: des

      }
    }
  },


  {
    path: "/MRNumber",
    name: "MRNumber",
    component: MRNumber,
    meta: {
      title: 'MRNumber',
      content: {
        keywords: keywordinfo,
        description: des

      }
    }
  },

  {
    path: "/ShowDataV",
    name: "ShowDataV",
    component: ShowDataV,
    meta: {
      title: 'ShowDataV',
      content: {
        keywords: keywordinfo,
        description: des

      }
    }
  },
];

//实例化VueRouter并将routes添加进去
const router = new VueRouter({
  //ES6简写，等于routes：routes
  routes,
});


//抛出这个这个实例对象方便外部读取以及访问
export default router